import GameBoard from "./Gameboard";

function App(){
    return(
        <div className="app-container">
            <GameBoard />
        </div>
    )
}

export default App
